// @flow

import React, { useState } from 'react'

import './AdminTypeFilter.css'

type Props = {
  changeFilter: Function,
  currentFilter: Function
}

function AdminTypeFilter ({ changeFilter, currentFilter }: Props) {
  const filter = currentFilter && currentFilter.alt ? currentFilter.alt : ''
  const [selected, setSelected] = useState(filter)

  const handleClick = (type) => {
    if (selected === type) {
      setSelected('')
      changeFilter(Object.assign({}, currentFilter, { alt: '' }))
      return
    }
    setSelected(type)
    changeFilter(Object.assign({}, currentFilter, { alt: type }))
  }

  return (
    <>
      <div className='Header'>
        <div>
          <span className='HeaderText'>Filter by Admin Type</span>
        </div>
      </div>

      <div className='FilterByContent'>
        <div className='FilterByRow'>
          <div className='FilterByColumn'>
            <ul className='AdminTypeItemContainer'>
              <li
                className={(selected === '') ? 'AdminTypeItem selected' : 'AdminTypeItem'}
                onClick={() => handleClick('')}>All Administrators</li>
              <li
                key='Master'
                className={(selected === 'ACCOUNT_ADMIN') ? 'AdminTypeItem selected' : 'AdminTypeItem'}
                onClick={() => handleClick('ACCOUNT_ADMIN')}>System Administrator</li>
              <li
                key='App'
                className={(selected === 'APP_PROFILE_ADMIN') ? 'AdminTypeItem selected' : 'AdminTypeItem'}
                onClick={() => handleClick('APP_PROFILE_ADMIN')}>Profile Administrator</li>
              <li
                key='Creators'
                className={(selected === 'CONTENT_PUBLISHER') ? 'AdminTypeItem selected' : 'AdminTypeItem'}
                onClick={() => handleClick('CONTENT_PUBLISHER')}>Content Publisher</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default AdminTypeFilter
